import { RealtimeRequestLockedDto } from "@hd/types/dto/contact/realtime-request-locked.dto";
import { RealtimeRequestUnlockedDto } from "@hd/types/dto/contact/realtime-request-unlocked.dto";
import { RealtimeUserInfoDto } from "@hd/types/dto/contact/realtime-user-info.dto";
import { RealtimeChatMessageDto } from "@hd/types/dto/realtime-message/realtime-chat-message.dto";
import { createContext } from "react";

interface HubContextType {
  subscribe: (
    companyId: number,
    hubCallbacks: HubContextCallbacks,
    customUserId?: string,
  ) => Promise<void>;
  unsubscribe: (
    companyId: number,
    hubCallbacks: HubContextCallbacks,
    customUserId?: string,
  ) => Promise<void>;
}

export interface HubContextCallbacks {
  onMessages?: (messages: RealtimeChatMessageDto[]) => void;
  onUsers?: (users: RealtimeUserInfoDto[]) => void;
  onQuotationLocked?: (quotationData: RealtimeRequestLockedDto) => void;
  onQuotationUnlocked?: (quotationData: RealtimeRequestUnlockedDto) => void;
  onRequestLocked?: (quotationData: RealtimeRequestLockedDto) => void;
  onRequestUnlocked?: (quotationData: RealtimeRequestUnlockedDto) => void;
}

export const HubContext = createContext<HubContextType>({
  subscribe: async () => {},
  unsubscribe: async () => {},
});
